import { defineMessages } from 'react-intl';

export const wishlistMessages = defineMessages({
  toggle: {
    id: 'wishlist.linkSharer.toggle',
    defaultMessage: 'Zkopírovat odkaz na seznam',
  },
  header: {
    id: 'wishlist.linkSharer.header',
    defaultMessage: 'Podělte se o své oblíbené produkty',
  },
  shareLabel: {
    id: 'wishlist.linkSharer.label',
    defaultMessage: 'Odkaz ke sdílení:',
  },
  clipboard: {
    id: 'wishlist.linkSharer.clipboard',
    defaultMessage: 'Zkopírováno do schránky',
  },
  clipboardFail: {
    id: 'wishlist.linkSharer.clipboardFail',
    defaultMessage: 'Kopírování se nezdařilo, zkopírujte pomocí Ctrl+C',
  },
  emptyWishlistMessage: {
    id: 'wishlist.empty.message',
    defaultMessage: 'Seznam je prazdný',
  },
  emptyWishlistGuide: {
    id: 'wishlist.empty.subMessage',
    defaultMessage: 'Klepnutím na srdíčko přidáte produkt do seznamu.',
  },
  emptyWishlistButton: {
    id: 'wishlist.empty.button',
    defaultMessage: 'Prohlédnout produkty',
  },
  invalidUrl: {
    id: 'wishlist.invalidUrl',
    defaultMessage: 'Odkaz uz neni platny',
  },
  invalidUrlExplanation: {
    id: 'wishlist.invalidUrl.explanation',
    defaultMessage:
      'Sdílené seznamy přání mají omezenou platnost a tento mezitím vypršel. Pro zobrazení si vyžádej nový odkaz.',
  },
});
